import React from 'react';
import { VIEW_SCHEMA_MODE } from '../constants';

export const DefaultValue = {
  plaza: {},
  schema: {
    connection: {},
    mode: VIEW_SCHEMA_MODE,
    events: {
      onDrop: (event) => {
        console.log('This is default node drop handler, you should redefine it', event);
      },
    },
  },
  node: {
    isConnected: () => false,
    periodicallyLoadDynamicData: false,
    click: (event, node) => {
      console.log('This is default node click handler, you should redefine it', event, node);
    },
    connectionSocketOut: {
      eventHandlers: {},
    },
    connectionSocketIn: {
      eventHandlers: {},
    },
  },
};

export const SchemaDisplayContext = React.createContext(DefaultValue);
